import { connect } from "react-redux";
import DecisionLog from "./DecisionLog";
import {
  allDecisionLogs,
  decisionLogPagination,
  decisionLogLoading,
  decisionLogPageLoading,
} from "../../store/selectors/decisionLog.selector";
import {
  getDecisionLogRequest,
  createDecisionLogRequest,
  updateDecisionLogRequest,
  deleteDecisionLogRequest,
  sortDecisionLogRequest,
} from "../../store/actions/decisionLog.actions";

const mapDispatchToProps = {
  getDecisionLogRequest,
  createDecisionLogRequest,
  updateDecisionLogRequest,
  deleteDecisionLogRequest,
  sortDecisionLogRequest,
};

const mapStateToProps = (state) => {
  const allDecisionLogsData = allDecisionLogs(state);
  const pagination = decisionLogPagination(state);
  const loading = decisionLogLoading(state);
  const pageLoading = decisionLogPageLoading(state);

  return {
    allDecisionLogs: allDecisionLogsData,
    pagination,
    loading,
    pageLoading,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DecisionLog); 